import React, { useEffect } from "react";
import { goBack } from "connected-react-router";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import Loader from "pages/_components/Loader";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import EndorseEchekSummaryBody from "./components/Summary";
import EndorseMultipleEchekSummaryBody from "./components/MultipleSummary";

const EndorseSummaryPage = () => {
    const { echeqsEndorseData: endorseData, echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const { echeckTicket } = useSelector((state) => state.echecks);
    const { dispatch } = useConfirmTransaction(endorseData, echeckTicket, "echecks/action/endorse");
    const willCancel = endorseData?.endorseData?.cancelTransaction;
    const multipleEcheq = echeqAction?.echeqList?.length > 1;

    useEffect(() => {
        if (isEmpty(echeqAction)) {
            dispatch(goBack());
        }
    }, [dispatch]);

    if (isEmpty(echeqAction)) {
        return <Loader />;
    }

    // eslint-disable-next-line consistent-return
    const selectAction = () => {
        if (echeqAction?.action !== "NEGOTIATE") {
            return echeckActions.endorseEcheq;
        }
    };

    return (
        <>
            <Notification scopeToShow="echecks/endorse/confirm" />
            <ResponsiveHeader id={multipleEcheq ? "echecks.multiple.endorse" : "echecks.endorse"} />
            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id={willCancel ? "payments.cancel.title" :  "echecks.summary.confirm"} />
                    </h2>

                    {multipleEcheq ? (
                        <EndorseMultipleEchekSummaryBody
                            beneficiary={
                                endorseData?.endorseData?.idTransaction
                                    ? endorseData?.endorseData?.beneficiary
                                    : endorseData?.beneficiary
                            }
                            type={endorseData?.endorseData?.type}
                            reference={endorseData?.endorseData?.reference}
                            referencevalue={endorseData?.endorseData?.referencevalue}
                            echeqList={echeqAction?.echeqList}
                            cancelReason={endorseData?.endorseData?.reason}
                        />
                    ) : (
                         <EndorseEchekSummaryBody
                            beneficiary={
                                endorseData?.endorseData?.idTransaction
                                    ? endorseData?.endorseData?.beneficiary
                                    : endorseData?.beneficiary
                            }
                            type={endorseData?.endorseData?.type}
                            reference={endorseData?.endorseData?.reference}
                            referencevalue={endorseData?.endorseData?.referencevalue}
                            echeqList={echeqAction?.echeqList}
                        />
                    )}

                    <GeneralCredentialForm
                        hideIndications
                        transactionData={{ endorseData, echeqAction }}
                        action={willCancel ? echeckActions.cancelTransfer : selectAction()}
                        isCancel={willCancel}
                        idActivity={"endorse.echeq.activity"}
                        disableContinueIfEmpty
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default EndorseSummaryPage;
